import { Component, NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { RouterModule } from '@angular/router';
// TODO - monitor this PR, it may remove the need for this patch - https://github.com/angular/angular/pull/43441
import { setUpLocationSync } from './core/routes/angular-router-upgrade.patch';

import { PublicAngularJSModule } from '../ajs-app/app.module.ajs';

/**
 * This module is written at the beginning of the upgrade process.
 * It does not need to change with the upgrade process.
 */

@Component({ template: `` })
export class EmptyComponent { }

@NgModule({
    declarations: [
        EmptyComponent
    ],
    imports: [
        UpgradeModule,
        RouterModule.forChild([
            {
                path: '**',
                component: EmptyComponent,
                data: {
                    isAngularJsRoute: true
                }
            }
        ])
    ]
})
export class Ng1WrapperModule {
    // The constructor is called only once, so we bootstrap the application
    // only once, when we first navigate to the legacy part of the app.
    constructor(upgrade: UpgradeModule) {
        upgrade.bootstrap(document.body, [PublicAngularJSModule], { strictDi: true });
        // BEWARE! setUpLocationSync causes an duplicate navigation events
        // https://github.com/angular/angular/issues/21610
        setUpLocationSync(upgrade);
    }
}
